import React, { useEffect, useState } from 'react';
import CourseDetails from './CourseDetails';
import CourseTabs from './CourseTabs';
import SideCard from './SideCard';
import Carousel from './Carousel';
import { useParams } from 'react-router-dom';
import coursesService from '../../../services/coursesService';

function MainContent() {
  const { slug } = useParams();
  const [course, setCourse] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fonction pour récupérer les détails du cours (+ modules/leçons via /full)
  const fetchCourseDetails = async (courseSlug) => {
    try {
      setLoading(true);
      const data = await coursesService.getCourseBySlug(courseSlug);
      const courseData = data?.id ? data : (data?.data ?? null);
      if (!courseData) {
        setError('Cours non trouvé');
        return;
      }
      // Charger les modules et leçons via l'endpoint /full
      try {
        const fullData = await coursesService.getCourseFull(courseData.id);
        const fullCourse = fullData?.id ? fullData : (fullData?.data ?? courseData);
        setCourse(fullCourse);
      } catch {
        // Si /full échoue, on utilise quand même le cours de base
        setCourse(courseData);
      }
    } catch (err) {
      setError('Erreur de connexion au serveur');
      console.error('Erreur:', err);
    }
  };

  useEffect(() => {
    if (slug) {
      fetchCourseDetails(slug);
    }
  }, [slug]);

  useEffect(() => {
    if (course) {
      setLoading(false);
    }
  }, [course]);

  if (loading) {
    return (
      <div className="flex justify-center items-center py-12">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
         </div>
    );
  }

  if (error) {
    return (
      <div className="flex justify-center items-center min-h-64">
        <div className="text-red-500 dark:text-red-400">{error}</div>
      </div>
    );
  }

  if (!course) {
    return (
      <div className="flex justify-center items-center min-h-64">
        <div className="text-gray-600 dark:text-gray-300">Cours non trouvé</div>
      </div>
    );
  }

  return (
    <div className='pt-28 px-4 md:px-8 lg:px-16 bg-white font-sans min-h-screen'>
      <section className="max-w-7xl mx-auto relative">
        {/* Section avec position relative pour contenir la SideCard */}
        <div className="relative">
          <CourseDetails course={course} />
          <SideCard course={course} />
        </div>
        <CourseTabs course={course} />
      </section>

      <Carousel courseCurrent={course} />
    </div>
  );
}

export default MainContent;